import { Box, Typography } from '@mui/material'
import {
  plcAboutParagraphs,
  plcClosingParagraph,
  plcGroupPhoto,
  plcProgramFeatures,
} from '../../data/plcContent'
import { headerHeight } from '../common/headerLayout'

/** Offset below sticky site header so the label sits at the top of the viewport */
const STICKY_TOP_OFFSET = {
  md: headerHeight.md + 20,
  lg: headerHeight.lg + 20,
}

const bodyTextSx = {
  fontSize: { xs: 16, sm: 22, md: 26, lg: 26 },
  lineHeight: 'normal',
  fontWeight: 400,
  color: '#000',
}

function CompactFeatureCard({ title, description, iconSrc, iconBgColor }) {
  return (
    <Box
      sx={{
        height: '100%',
        bgcolor: '#fffefa',
        borderRadius: '20px',
        boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
        p: '24px',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '10px',
            bgcolor: iconBgColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            p: '10px',
            boxSizing: 'border-box',
          }}
        >
          <Box component="img" src={iconSrc} alt="" sx={{ width: 32, height: 32, display: 'block', objectFit: 'contain' }} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontSize: { xs: 16, md: 22 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#000',
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 16, md: 16 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: 'rgba(0,0,0,0.8)',
              mt: '4px',
            }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default function PlcAboutSection() {
  return (
    <Box component="section" sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: { md: 'space-between' },
          alignItems: { xs: 'flex-start', md: 'stretch' },
          gap: { xs: 2, md: 4 },
        }}
      >
        <Box
          sx={{
            flexShrink: 0,
            width: { xs: '100%', md: 'auto' },
            maxWidth: { md: 360, lg: 400 },
          }}
        >
          <Typography
            component="h3"
            sx={{
              fontSize: { xs: 22, md: 22 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#000',
              position: { xs: 'static', md: 'sticky' },
              top: STICKY_TOP_OFFSET,
              zIndex: 1,
              bgcolor: '#fffefa',
            }}
          >
            What is Public Leadership Camp?
          </Typography>
        </Box>

        <Box
          sx={{
            width: '100%',
            maxWidth: { md: 1000 },
            minWidth: 0,
            flex: { md: '1 1 auto' },
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 4, md: 4 },
          }}
        >
          {plcAboutParagraphs.map((paragraph) => (
            <Typography key={paragraph.slice(0, 40)} sx={bodyTextSx}>
              {paragraph}
            </Typography>
          ))}

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
              gap: 3,
            }}
          >
            {plcProgramFeatures.map((feature) => (
              <CompactFeatureCard key={feature.title} {...feature} />
            ))}
          </Box>

          <Typography sx={bodyTextSx}>{plcClosingParagraph}</Typography>

          <Box
            sx={{
              width: '100%',
              height: { xs: 280, sm: 400, lg: 550 },
              borderRadius: 0,
              overflow: 'hidden',
            }}
          >
            <Box
              component="img"
              src={plcGroupPhoto}
              alt="Public Leadership Camp participants"
              sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
